import React, { useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'

import { LogoLogin } from '../../../assets/imgs'
import { Btn, CustomModal, BadgeStatusEntrega } from '../../../components'
import {
  getDeliveryHome,
  getDeliveryHomeByProduct,
} from '../../../services/api/https/deliveries/delivery.http'
import { getUsuarioInfo } from '../../../services/localstorage/localstorage.service'
import {
  showMessageBox,
  showLoadingBox,
  hideLoadingBox,
} from '../../../store/actions/system.actions'

import './Home.css'

function Home({ history, system, dispatch }) {
  const [notaFiscal, setNotaFiscal] = useState('')
  const [produto, setProduto] = useState('')

  // Estados para busca por Nota Fiscal
  const [showModalEmpresasNF, setShowModalEmpresasNF] = useState(false)
  const [empresasNF, setEmpresasNF] = useState([])

  // Estados para busca por Produto
  const [showModalEmpresasProduto, setShowModalEmpresasProduto] = useState(false)
  const [showModalNotasProduto, setShowModalNotasProduto] = useState(false)
  const [empresasProduto, setEmpresasProduto] = useState([])
  const [notasProduto, setNotasProduto] = useState([])

  const handleBuscar = async () => {
    if (!notaFiscal.trim()) {
      dispatch(showMessageBox(null, 'Por favor, digite uma nota fiscal'))
      return
    }

    const { selectedTp } = system
    if (!selectedTp && selectedTp !== 0) {
      dispatch(showMessageBox(null, 'Por favor, selecione um TP'))
      return
    }

    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione um TP antes de buscar'))
      return
    }

    const usuario = getUsuarioInfo()

    try {
      dispatch(showLoadingBox('Buscando nota fiscal...', 'Aguarde'))
      const result = await getDeliveryHome(usuario.id, selectedTp, notaFiscal)
      dispatch(hideLoadingBox())

      if (!result || result.length === 0) {
        dispatch(showMessageBox(null, 'Nenhuma entrega encontrada com essa nota fiscal'))
        return
      }

      if (result.length === 1) {
        // Redireciona diretamente para os detalhes da entrega
        history.push('/main/entregas/entrega-detalhes', { entrega: result[0] })
      } else {
        // Abre modal para seleção
        setEmpresasNF(result)
        setShowModalEmpresasNF(true)
      }
    } catch (error) {
      dispatch(hideLoadingBox())
      dispatch(
        showMessageBox(null, error.message || 'Erro ao buscar nota fiscal. Tente novamente.'),
      )
    }
  }

  const handleSelectEmpresaNF = entrega => {
    setShowModalEmpresasNF(false)
    history.push('/main/entregas/entrega-detalhes', { entrega })
  }

  const handleBuscarProduto = async () => {
    if (!produto.trim()) {
      dispatch(showMessageBox(null, 'Por favor, digite o nome do produto'))
      return
    }

    const { selectedTp } = system
    if (!selectedTp && selectedTp !== 0) {
      dispatch(showMessageBox(null, 'Por favor, selecione um TP'))
      return
    }

    if (selectedTp === 0) {
      dispatch(showMessageBox(null, 'Selecione um TP antes de buscar'))
      return
    }

    const usuario = getUsuarioInfo()

    try {
      dispatch(showLoadingBox('Buscando produto...', 'Aguarde'))
      const result = await getDeliveryHomeByProduct(usuario.id, selectedTp, produto)
      dispatch(hideLoadingBox())

      if (!result || result.length === 0) {
        dispatch(
          showMessageBox(
            null,
            'Nenhuma nota fiscal com esse produto foi encontrada nos ultimos 30 dias',
          ),
        )
        return
      }

      // Agrupar por empresa
      const empresasUnicas = [...new Set(result.map(item => item.company_id))]

      if (empresasUnicas.length > 1) {
        // Múltiplas empresas - abre modal para selecionar empresa
        const empresasAgrupadas = empresasUnicas.map(companyId => {
          return result.find(item => item.company_id === companyId)
        })
        setEmpresasProduto(empresasAgrupadas)
        setNotasProduto(result)
        setShowModalEmpresasProduto(true)
      } else {
        // Uma única empresa - abre direto o modal de notas
        setNotasProduto(result)
        setShowModalNotasProduto(true)
      }
    } catch (error) {
      dispatch(hideLoadingBox())
      dispatch(showMessageBox(null, error.message || 'Erro ao buscar produto. Tente novamente.'))
    }
  }

  const handleSelectEmpresaProduto = companyId => {
    const notasDaEmpresa = notasProduto.filter(nota => nota.company_id === companyId)
    setNotasProduto(notasDaEmpresa)
    setShowModalEmpresasProduto(false)
    setShowModalNotasProduto(true)
  }

  const handleSelectNotaProduto = entrega => {
    setShowModalNotasProduto(false)
    history.push('/main/entregas/entrega-detalhes', { entrega })
  }

  return (
    <div className="Home">
      <img src={LogoLogin} alt="Logo - Co - Logística" />

      <div className="Home__search-container">
        <div className="Home__buscar-nota-fiscal">
          <h3>Buscar Nota Fiscal</h3>
          <div className="Home__buscar-container">
            <div className="Home__input-group">
              <label htmlFor="notaFiscal">Nota Fiscal:</label>
              <InputText
                id="notaFiscal"
                value={notaFiscal}
                onChange={e => setNotaFiscal(e.target.value)}
                placeholder="Digite a nota fiscal"
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    handleBuscar()
                  }
                }}
              />
            </div>
            <Btn onClick={handleBuscar}>Buscar</Btn>
          </div>
        </div>

        <div className="Home__buscar-produto">
          <h3>Buscar por Produto</h3>
          <div className="Home__buscar-container">
            <div className="Home__input-group">
              <label htmlFor="produto">Produto:</label>
              <InputText
                id="produto"
                value={produto}
                onChange={e => setProduto(e.target.value)}
                placeholder="Digite o nome ou código do produto"
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    handleBuscarProduto()
                  }
                }}
              />
            </div>
            <Btn onClick={handleBuscarProduto}>Buscar</Btn>
          </div>
        </div>
      </div>

      {/* Modal para Busca por Nota Fiscal */}
      <CustomModal
        header="Selecione a Empresa"
        isVisible={showModalEmpresasNF}
        onClose={() => setShowModalEmpresasNF(false)}
        width="600px"
      >
        <div className="Home__modal-content">
          <p className="Home__modal-instruction">
            Há {empresasNF.length} empresas com essa nota fiscal no sistema. Selecione a que deseja:
          </p>
          <ul className="Home__empresa-list">
            {empresasNF.map((entrega, index) => (
              <li key={index} onClick={() => handleSelectEmpresaNF(entrega)}>
                <div className="Home__empresa-item">
                  <strong>{entrega.company_name}</strong>
                  <div className="Home__empresa-info">
                    <span>Cliente: {entrega.nomeFantasia}</span>
                    <span>Cidade: {entrega.city}</span>
                    <span>Status: {entrega.status}</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </CustomModal>

      {/* Modal para Selecionar Empresa - Busca por Produto */}
      <CustomModal
        header="Selecione a Empresa"
        isVisible={showModalEmpresasProduto}
        onClose={() => setShowModalEmpresasProduto(false)}
        width="600px"
      >
        <div className="Home__modal-content">
          <p className="Home__modal-instruction">
            Há {empresasProduto.length} empresas com esse produto no sistema. Selecione a que
            deseja:
          </p>
          <ul className="Home__empresa-list">
            {empresasProduto.map((entrega, index) => (
              <li key={index} onClick={() => handleSelectEmpresaProduto(entrega.company_id)}>
                <div className="Home__empresa-item">
                  <strong>{entrega.company_name}</strong>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </CustomModal>

      {/* Modal para Selecionar Nota Fiscal - Busca por Produto */}
      <CustomModal
        header="Selecione a Nota Fiscal"
        isVisible={showModalNotasProduto}
        onClose={() => setShowModalNotasProduto(false)}
        width="600px"
      >
        <div className="Home__modal-content">
          <p className="Home__modal-instruction">
            {notasProduto.length === 1
              ? 'Foi encontrada 1 nota fiscal com esse produto:'
              : `Encontradas ${notasProduto.length} notas fiscais com esse produto. Selecione a que deseja:`}
          </p>
          <ul className="Home__empresa-list">
            {notasProduto.map((nota, index) => (
              <li key={index} onClick={() => handleSelectNotaProduto(nota)}>
                <div className="Home__empresa-item">
                  <strong>NF: {nota.invoice_number || nota.identifier}</strong>
                  <div className="Home__empresa-info">
                    <span>Cliente: {nota.nomeFantasia}</span>
                    <span>Cidade: {nota.city}</span>
                    <span>Bairro: {nota.district}</span>
                    <span>
                      Status: <BadgeStatusEntrega status={nota.status} />
                    </span>
                    <span>Importado em: {new Date(nota.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </CustomModal>
    </div>
  )
}

const mapStateToProps = ({ system }) => ({ system })
export default connect(mapStateToProps)(withRouter(Home))
